/*无环境依赖（既不依赖 Node.js 特有 API，也不依赖浏览器 API）
仅包含静态常量、纯函数工具、类型定义
可同时被构建时和运行时代码导入，是连接两者的 “桥梁”*/

export const maxDisplayWidth: number = 500;
export const designWidth: number = 360;
export const dkPadDesignWidth: number = 834;
export const unitPrecision: number = 5;

// px 转 rem 配置
export const iphone6W = 375; // iPhone 6 宽度
export const divisor = 10; // 用于计算设计稿宽度比值的除数
export const designRatio = designWidth / divisor; // 设计稿宽度比值
export const dkPadDesignRatio = dkPadDesignWidth / divisor; // 多科pad设计稿宽度比值 正确计算px到rem的比例
export const iphone6Ratio = iphone6W / divisor; // iPhone 6 宽度与除数的比值
